import { render, staticRenderFns } from "./NevronEmpty.vue?vue&type=template&id=4f426b04&"
import script from "./NevronEmpty.vue?vue&type=script&lang=ts&"
export * from "./NevronEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports